import axiosInstance from './apiInterceptor';
import reportsAxiosInstance from './reportsInterceptors';
import sftpAxiosInstance from './sftpInterceptor';
// GET API Call
export const globalGetService = (url, params, retry=2) => {
  return new Promise(
    function(resolve, reject){
      axiosInstance({
        method: 'GET',
        url: url,
        params: params
      })
      .then(response => {
        resolve(response);
      })
      .catch(error=>{
        if(retry>0){
          globalGetService(url, params, retry-1)
        }
        resolve(error);
      })
    }
  )
}
// POST API Call
export const globalPostService = (url, data, retry=2) => {
  return new Promise(
    function(resolve, reject){
      axiosInstance({
        method: 'POST',
        url: url,
        data: data
      })
      .then(response => {
        resolve(response);
      })
       .catch(error=>{
        if(retry>0){
          globalPostService(url, data, retry-1)
        }
        resolve(error);
      })
    }
  )
}
// PUT API Call
export const globalPutService = (url, data) => {
  return new Promise(
      function(resolve, reject){
        axiosInstance({
          method: 'PUT',
          url: url,
          data: data
        })
        .then(response => {
          resolve(response);
        })
      }
  )
}
// DELETE API Call
export const globalDeleteService = (url, data) => {
  return new Promise(
    function(resolve, reject){
      axiosInstance({
        method: 'DELETE',
        url: url,
        data: data
      })
      .then(response => {
        resolve(response);
      })
    }
  )
}
export const globalExportService = (url, queryParams={}, type,instance) => {
   if(type =='marketing'){
      return new Promise((resolve, reject)=>{
      reportsAxiosInstance(
        (instance!=='avationInstance')?({
        method: 'GET',
        url: url,
        // responseType: 'blob',
        params: queryParams
      }):({
        method: 'GET',
        url: url,
        responseType: 'blob',
        params: queryParams
      }))
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error)
        })
      })
    }else{
  return new Promise(
    function(resolve, reject){
      axiosInstance({
        method: 'GET',
        url: url,
        responseType: 'blob',
        params: queryParams
      })
      .then(response => {
        resolve(response);
      })
    }
  )
}
}

export const globalFileUploadService = (url, data, config) => {
  return new Promise(
    function(resolve, reject){
      axiosInstance.post(url, data, config)
      .then(function (response) {
        resolve(response);
      })
    }
  )
}

export const globalFileUploadPutService = (url, data, config) => {
  return new Promise(
    function(resolve, reject){
      axiosInstance.put(url, data, config)
      .then(function (response) {
        resolve(response);
      })
    }
  )
}
export const globalDownloadService = (url, data) => {
  return new Promise(
    function(resolve, reject){
      axiosInstance({
        method: 'POST',
        url: url,
        data: data,
        responseType: 'arraybuffer',
      })
      .then(response => {
        resolve(response);
      })
    }
  )
}
//sftp API call
export const globalSftpGetService = (url, params) => {
  return new Promise(
    function(resolve, reject){
      sftpAxiosInstance({
        method: 'GET',
        url: url,
        params: params
      })
      .then(response => {
        resolve(response);
      })
    }
  )
}
